import React from "react";
import styled from "styled-components";
import { colors } from "@commonsku/styles";
import { Provider, SkuBot } from "@commonsku/design-system";

export interface AgentAvatarIconProps {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

const IconContainer = styled.div<{ size?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  aspect-ratio: 1;
  width: ${(props) => (props.size ? `${props.size}px` : "100%")};
`;

/**
 * Renders the skubot icon centered within a square avatar slot, sized to
 * fill the available avatar space (as an <img className="avatar"> would) by
 * omitting `size`, or pinned to an exact pixel width to match a sibling
 * avatar's fixed dimensions. The container is a 1:1 square -- via
 * `aspect-ratio` -- so the icon, whose own aspect ratio is much wider than
 * tall, sits centered within it rather than hugging the top.
 */
export const AgentAvatarIcon = ({ size, style, className }: AgentAvatarIconProps) => (
  <IconContainer size={size} style={style} className={className}>
    <Provider>
      <SkuBot color={colors.teal.main} width="100%" height="auto" />
    </Provider>
  </IconContainer>
);

export default AgentAvatarIcon;
